import React from 'react';
import Header from "../components/Header";
import Footer from "../components/Footer";

const Cart = () => {
    return (
        <>
            <Header />
            <div className="container mt-5 mb-5">
                <p>No Cart Available</p>
            </div>
            <Footer />
        </>
    );
};

export default Cart;
